
import { Component, inject } from '@angular/core';
import { Nl2brPipe } from '../pipes/nl2br.pipe';
import { DIALOG_DATA, DialogOptions, NgbActiveModal } from './dialogs';

/**
 * AlertOptions
 */
export interface AlertOptions extends DialogOptions {
  okText: string;
}
@Component({
  selector: 'dialog-alert',
  standalone: true,
  imports: [Nl2brPipe],
  template: `
    @if (data.title) {
      <header class="modal-header">
        <h3 class="modal-title">{{data.title}}</h3>
      </header>
    }
    
    <div class="modal-body" [innerHTML]="data.message | nl2br"></div>
    
    <footer class="modal-footer">
      <div class="d-flex justify-content-center w-100">
        <button type="submit" class="btn btn-secondary w-50" ngbAutofocus (click)="modal.close(true)">{{data.okText}}</button>
      </div>
    </footer>
    `,
})
export class AlertComponent {
  public modal  = inject(NgbActiveModal);
  public data   = inject<AlertOptions>(DIALOG_DATA);
}
